<template>
    <div>
        <v-menu
            v-model="modal"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    :value="computedDateFormattedMomentjs"
                    :label="label"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    placeholder="e.g 06-07-2022"
                    :disabled="disabled"
                    v-bind="attrs"
                    v-on="on"
                    :color="color ? color : inputColor"
                    outlined
                    :background-color="color ? `${color} lighten-5` : backgroundColor"
                    :clearable="!readonly"
                    @click:clear="clear"
                    dense
                    :hint="hint"
                    :persistent-hint="persistentHint"
                    hide-details="auto"
                    :rules="rules"
                ></v-text-field>
            </template>
            <v-date-picker
                v-model="date"
                :max="birthDayPicker ? (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10) : null"
                :active-picker.sync="activePicker"
                :readonly="readonly"
                :disabled="disabled"
                :color="color ? color : inputColor"
                locale="fr-fr"
                @input="save"
            ></v-date-picker>
        </v-menu>
        <input type="hidden"/>
    </div>
</template>

<script>
import {computed, onMounted, ref, watch} from "vue";
import useTools from "@/use/Tools";
import useSharedData from "@/use/SharedData";

export default {
    props: {
        value: String,
        label: String,
        color: String,
        min: String,
        readonly: Boolean,
        disabled: Boolean,
        birthDayPicker: Boolean,
        rules: Array,
        hint: String,
        persistentHint: Boolean,
    },
    setup(props, {emit}) {
        const {$moment} = useTools();
        const {inputColor, backgroundColor} = useSharedData();

        const modal = ref(false);
        const date = ref(null);
        const activePicker = ref(null);

        const computedDateFormattedMomentjs = computed(() => date.value ? $moment(date.value).format("DD-MM-YYYY") : null);

        function save() {
            modal.value = false;
            emit("input", date.value);
        }

        function clear() {
            date.value = null;
            emit("input", null);
        }

        watch(() => modal.value, () => {
            if (props.birthDayPicker)
                modal.value && setTimeout(() => (activePicker.value = 'YEAR'))
        })

        watch(() => props.value, () => {
            date.value = props.value;
        });

        onMounted((() => {
            if (props.value)
                date.value = props.value;
        }));

        return {
            date,
            activePicker,
            modal,
            inputColor,
            backgroundColor,
            computedDateFormattedMomentjs,
            save,
            clear,
        }
    }
};
</script>